import React, { Component } from "react";
import { connect } from "react-redux";
import "./hsqDocument.scss";
import util from "../../_helpers/util";
import DatePicker from "react-datepicker";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import CustomSignaturePad from "../signaturePad/signaturePad";
import MandatorySymbol from "../common/MandatorySymbol";

const step = 6;
const page = "hsqDocument";
class HsqDocument extends Component {
    constructor(props) {
        super(props);
        const formattedDate = new Date();
        this.state = {
            canApply: true,
            form: {
                wcftLevel: "arduous",
                hsqQuestion1: "",
                hsqQuestion2: "",
                hsqQuestion3: "",
                hsqQuestion4: "",
                hsqQuestion5: "",
                hsqQuestion6: "",
                hsqQuestion7: "",
                hsqQuestion8: "",
                hsqQuestion9: "",
                hsqQuestion10: "",
                applicantAcknowledgment: "",
                applicantSignature: "",
                applicantPrintedName: "",
                applicantDate: formattedDate,
                consentReadBrochure: "",
                consentReadHSQ: "",
                testToBeTaken: "arduous_pack_test",
                consentSignature: "",
                consentPrintedName: "",
                consentDate: formattedDate,
                step: step,
            },
            errors: {},
        };
    }

    showRequiredFieldsPopup(firstError) {
        const errorElement =
            typeof firstError === "string"
                ? document.querySelector(`[name*="${firstError}"]`) ||
                  document.getElementById(firstError)
                : firstError;
        confirmAlert({
            title: "Required fields missing",
            message: "Please fill in all required fields before submitting.",
            buttons: [
                {
                    label: "OK",
                    onClick: () => {
                        if (errorElement) {
                            errorElement.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                            });
                            errorElement.focus();
                        }
                    },
                },
            ],
        });
    }

    submitForm(event) {
        event.preventDefault();
        if (!this.state.canApply) {
            confirmAlert({
                title: "Application Update Restricted",
                message: "You cannot update your job application as it may currently be under review or archived. Please email hr@firestormfire.com if you believe this is incorrect.",
                buttons: [
                    {
                        label: "Close",
                        onClick: () => { },
                    },
                ],
            });
            return;
        }

        // Validate required fields
        const errors = {};

        // Validate signatures
        if (!this.state.form.applicantSignature) {
            errors.applicantSignature = "Applicant signature is required";
        }
        if (!this.state.form.consentSignature) {
            errors.consentSignature = "Consent signature is required";
        }

        // Validate required checkboxes
        if (this.state.form.consentReadBrochure !== "yes") {
            errors.consentReadBrochure = "You must acknowledge that you have read the Work Capacity Test brochure";
        }
        if (this.state.form.consentReadHSQ !== "yes") {
            errors.consentReadHSQ = "You must acknowledge that you have read and understood the HSQ";
        }

        // Validate test selection
        if (!this.state.form.testToBeTaken) {
            errors.testToBeTaken = "Please select a test to be taken";
        }

        // Validate WCFT Level
        if (!this.state.form.wcftLevel) {
            errors.wcftLevel = "WCFT Level is required";
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ errors }, () => {
                this.showRequiredFieldsPopup(Object.keys(errors)[0]);
            });
            return;
        }

        // Additional HTML5 validation - use same popup and scroll to first invalid field
        const formElement = document.getElementById(page);
        if (formElement) {
            const inputs = formElement.querySelectorAll(
                "input, textarea, select"
            );
            let firstInvalid = null;
            for (let i = 0; i < inputs.length; i++) {
                const ele = inputs[i];
                if (ele.classList.contains(util._classes.blur)) continue;
                if (!util.validate(ele)) {
                    if (!firstInvalid) firstInvalid = ele;
                }
            }
            if (firstInvalid) {
                this.showRequiredFieldsPopup(firstInvalid);
                return;
            }
        }

        // Prepare form data with all HSQ fields and step
        const formData = {
            ...this.state.form,
            step: step
        };

        // Call the save API through the action prop
        if ("function" === typeof this.props.action) {
            this.props.action(formData, step);
        }
    }

    componentDidMount() {
        this.setDefaultData();
    }
    componentDidUpdate(prevProps) {
        const applicationDetails =
            this.props.api && this.props.api.aplicationDetail;
        const prevApplicationDetails =
            prevProps.api && prevProps.api.aplicationDetail;
        const shouldSetDefaultValues = !!(
            (applicationDetails && applicationDetails.hash) !==
            (prevApplicationDetails && prevApplicationDetails.hash)
        );

        if (shouldSetDefaultValues) {
            this.setDefaultData();
        }
    }

    setDefaultData() {
        if (this.props.api && this.props.api.aplicationDetail) {
            var data = this.props.api.aplicationDetail,
                obj = Object.assign({}, this.state.form);

            // Map API field names (snake_case) to form field names (camelCase)
            let form = util._merge(obj, data, {
                wcftLevel: "wcft_level",
                hsqQuestion1: "hsq_question1",
                hsqQuestion2: "hsq_question2",
                hsqQuestion3: "hsq_question3",
                hsqQuestion4: "hsq_question4",
                hsqQuestion5: "hsq_question5",
                hsqQuestion6: "hsq_question6",
                hsqQuestion7: "hsq_question7",
                hsqQuestion8: "hsq_question8",
                hsqQuestion9: "hsq_question9",
                hsqQuestion10: "hsq_question10",
                applicantAcknowledgment: "applicant_acknowledgment",
                applicantSignature: "applicant_signature",
                applicantPrintedName: "applicant_printed_name",
                applicantDate: {
                    target: "applicant_date",
                    filter: "date",
                },
                consentReadBrochure: "consent_read_brochure",
                consentReadHSQ: "consent_read_hsq",
                testToBeTaken: "test_to_be_taken",
                consentSignature: "consent_signature",
                consentPrintedName: "consent_printed_name",
                consentDate: {
                    target: "consent_date",
                    filter: "date",
                },
            });

            // Keep checkbox/radio values as they are from saved data, or empty if not set
            // Don't force default "no" values - let them remain empty if not saved

            // Ensure date fields are Date objects
            // Handle Unix timestamps (in seconds) - convert to milliseconds if needed
            const convertToDate = (dateValue, defaultValue) => {
                if (!dateValue) return defaultValue;
                if (dateValue instanceof Date) {
                    // Treat epoch (01/01/1970) as "no date" and use current date
                    if (dateValue.getTime() === 0) return defaultValue;
                    return dateValue;
                }

                // If it's a number (Unix timestamp), check if it's in seconds or milliseconds
                if (typeof dateValue === 'number') {
                    // Treat 0 (epoch) as "no date" and use current date
                    if (dateValue === 0) return defaultValue;
                    // If timestamp is less than year 2000 in milliseconds, it's likely in seconds
                    if (dateValue < 946684800000) {
                        return new Date(dateValue * 1000);
                    }
                    return new Date(dateValue);
                }

                // Try to parse as date string
                const parsed = new Date(dateValue);
                if (isNaN(parsed.getTime())) return defaultValue;
                // Treat epoch (01/01/1970) as "no date" and use current date
                if (parsed.getTime() === 0) return defaultValue;
                return parsed;
            };

            form.applicantDate = convertToDate(form.applicantDate, new Date());
            form.consentDate = convertToDate(form.consentDate, new Date());

            this.setState({
                canApply: data.can_apply,
                form: form,
            });
        }
    }

    blur(event) {
        util.blur(event);
    }

    setValue(event) {
        if (event.target.classList.contains("aplcn-has-error")) {
            event.target.classList.remove("aplcn-has-error");
        }
        util.setValue.call(this, event);
        if (util.isblurred(event.target)) {
            util.validate(event.target);
        }
        this.setState({
            errors: {
                ...this.state.errors,
                [event.target.name]: "",
            },
        });
    }

    handleDateChange(name, date) {
        util.setValue.call(this, null, {
            value: date,
            name: name,
        });
    }

    handleSignatureChange(signatureName, signatureValue) {
        this.setState({
            form: {
                ...this.state.form,
                [signatureName]: signatureValue,
            },
            errors: {
                ...this.state.errors,
                [signatureName]: signatureValue ? "" : "Signature is required",
            },
        });
    }

    render() {
        return (
            <div className="aplcn-form aplcn-form-two">
                <form method="post" onSubmit={this.submitForm.bind(this)} id={page} noValidate>
                    {/* Page 1: HEALTH SCREENING QUESTIONNAIRE (HSQ) */}
                    <div className="aplcn-form-section-head">
                        <h4>HEALTH SCREENING QUESTIONNAIRE (HSQ)</h4>
                    </div>

                    <div className="aplcn-form-row-main aplcn-has-inputs">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <label className="aplcn-label">WCFT Level <MandatorySymbol /></label>
                                <ul className="aplcn-checklist inline-radios wcft-level-radios">
                                    <li>
                                        <input
                                            value="arduous"
                                            type="radio"
                                            id="wcftLevel_arduous"
                                            onChange={(e) => {
                                                this.setValue.call(this, e);
                                                this.setState({
                                                    errors: {
                                                        ...this.state.errors,
                                                        wcftLevel: ""
                                                    }
                                                });
                                            }}
                                            name="form.wcftLevel"
                                            checked={this.state.form.wcftLevel === "arduous"}
                                            required
                                        />
                                        <label htmlFor="wcftLevel_arduous">
                                            <span className="aplcn-check-label">Arduous</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="moderate"
                                            type="radio"
                                            id="wcftLevel_moderate"
                                            disabled
                                            onChange={(e) => {
                                                this.setValue.call(this, e);
                                                this.setState({
                                                    errors: {
                                                        ...this.state.errors,
                                                        wcftLevel: ""
                                                    }
                                                });
                                            }}
                                            name="form.wcftLevel"
                                            checked={this.state.form.wcftLevel === "moderate"}
                                        />
                                        <label htmlFor="wcftLevel_moderate">
                                            <span className="aplcn-check-label">Moderate</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="light"
                                            type="radio"
                                            id="wcftLevel_light"
                                            disabled
                                            onChange={(e) => {
                                                this.setValue.call(this, e);
                                                this.setState({
                                                    errors: {
                                                        ...this.state.errors,
                                                        wcftLevel: ""
                                                    }
                                                });
                                            }}
                                            name="form.wcftLevel"
                                            checked={this.state.form.wcftLevel === "light"}
                                        />
                                        <label htmlFor="wcftLevel_light">
                                            <span className="aplcn-check-label">Light</span>
                                        </label>
                                    </li>
                                </ul>
                                {this.state.errors.wcftLevel && (
                                    <div className="aplcn-error-message" style={{ color: 'red', marginTop: '5px' }}>
                                        {this.state.errors.wcftLevel}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="aplcn-form-row-main aplcn-has-inputs">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    Assess your health needs by marking all statements, truthfully.
                                    The purpose is to identify individuals who may be at risk in taking the Work Capacity Test (WCT) and recommend an
                                    exercise program and/or medical examination prior to taking the WCT.
                                </p>
                                <p className="aplcn-desc">
                                    Potential and Returning employees are required to truthfully answer the following questions. The questions were
                                    designed, in consultation with occupational health physicians, to ensure you are aware of the strenuous activity in a
                                    WCT and to identify individuals who may be at risk when taking a WCT.
                                </p>
                                <p className="aplcn-desc">
                                    The HSQ is not a medical examination. Any medical concerns you have that place you or your health at risk should be
                                    reviewed with your personal physician prior to participating in the WCT. This is for your safety and wellbeing.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="aplcn-form-section-head">
                        <h5><strong>Check “Yes” or “No” in response to the following questions:</strong></h5>
                    </div>

                    {/* Question 1 */}
                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    1. During the past 12 months have you at any time (during physical activity or while resting) experienced pain, discomfort or pressure in your chest? <MandatorySymbol />
                                </p>
                                <ul className="aplcn-checklist inline-radios">
                                    <li>
                                        <input
                                            value="yes"
                                            type="radio"
                                            id="hsqQuestion1_yes"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion1"
                                            checked={this.state.form.hsqQuestion1 === "yes"}
                                            required
                                        />
                                        <label htmlFor="hsqQuestion1_yes">
                                            <span className="aplcn-check-label">Yes</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="no"
                                            type="radio"
                                            id="hsqQuestion1_no"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion1"
                                            checked={this.state.form.hsqQuestion1 === "no"}
                                        />
                                        <label htmlFor="hsqQuestion1_no">
                                            <span className="aplcn-check-label">No</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Question 2 */}
                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    2. During the past 12 months have you experienced difficulty breathing or shortness of breath, dizziness, fainting, or blackout? <MandatorySymbol />
                                </p>
                                <ul className="aplcn-checklist inline-radios">
                                    <li>
                                        <input
                                            value="yes"
                                            type="radio"
                                            id="hsqQuestion2_yes"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion2"
                                            checked={this.state.form.hsqQuestion2 === "yes"}
                                            required
                                        />
                                        <label htmlFor="hsqQuestion2_yes">
                                            <span className="aplcn-check-label">Yes</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="no"
                                            type="radio"
                                            id="hsqQuestion2_no"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion2"
                                            checked={this.state.form.hsqQuestion2 === "no"}
                                        />
                                        <label htmlFor="hsqQuestion2_no">
                                            <span className="aplcn-check-label">No</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Question 3 */}
                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    3. Do you have a blood pressure with systolic (top#) greater than 140 or diastolic (bottom #) greater than 90? <MandatorySymbol />
                                </p>
                                <ul className="aplcn-checklist inline-radios">
                                    <li>
                                        <input
                                            value="yes"
                                            type="radio"
                                            id="hsqQuestion3_yes"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion3"
                                            checked={this.state.form.hsqQuestion3 === "yes"}
                                            required
                                        />
                                        <label htmlFor="hsqQuestion3_yes">
                                            <span className="aplcn-check-label">Yes</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="no"
                                            type="radio"
                                            id="hsqQuestion3_no"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion3"
                                            checked={this.state.form.hsqQuestion3 === "no"}
                                        />
                                        <label htmlFor="hsqQuestion3_no">
                                            <span className="aplcn-check-label">No</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Question 4 */}
                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    4. Have you ever been diagnosed or treated for any heart disease, heart murmur, chest pain (angina), palpitations (irregular beat), or heart attack? <MandatorySymbol />
                                </p>
                                <ul className="aplcn-checklist inline-radios">
                                    <li>
                                        <input
                                            value="yes"
                                            type="radio"
                                            id="hsqQuestion4_yes"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion4"
                                            checked={this.state.form.hsqQuestion4 === "yes"}
                                            required
                                        />
                                        <label htmlFor="hsqQuestion4_yes">
                                            <span className="aplcn-check-label">Yes</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="no"
                                            type="radio"
                                            id="hsqQuestion4_no"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion4"
                                            checked={this.state.form.hsqQuestion4 === "no"}
                                        />
                                        <label htmlFor="hsqQuestion4_no">
                                            <span className="aplcn-check-label">No</span>
                                        </label>
                                    </li>
                                </ul>
                                {this.state.errors.hsqQuestion4 && (
                                    <div className="aplcn-error-message aplcn-field-error" data-error-for="hsqQuestion4" style={{ color: 'red', marginTop: '5px' }}>
                                        {this.state.errors.hsqQuestion4}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Question 5 */}
                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    5. Have you ever had heart surgery, angioplasty, or a pace maker, valve replacement, or heart transplant? <MandatorySymbol />
                                </p>
                                <ul className="aplcn-checklist inline-radios">
                                    <li>
                                        <input
                                            value="yes"
                                            type="radio"
                                            id="hsqQuestion5_yes"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion5"
                                            checked={this.state.form.hsqQuestion5 === "yes"}
                                            required
                                        />
                                        <label htmlFor="hsqQuestion5_yes">
                                            <span className="aplcn-check-label">Yes</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="no"
                                            type="radio"
                                            id="hsqQuestion5_no"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion5"
                                            checked={this.state.form.hsqQuestion5 === "no"}
                                        />
                                        <label htmlFor="hsqQuestion5_no">
                                            <span className="aplcn-check-label">No</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Question 6 */}
                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    6. Do you have a resting pulse greater than 100 beats per minute? <MandatorySymbol />
                                </p>
                                <ul className="aplcn-checklist inline-radios">
                                    <li>
                                        <input
                                            value="yes"
                                            type="radio"
                                            id="hsqQuestion6_yes"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion6"
                                            checked={this.state.form.hsqQuestion6 === "yes"}
                                            required
                                        />
                                        <label htmlFor="hsqQuestion6_yes">
                                            <span className="aplcn-check-label">Yes</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="no"
                                            type="radio"
                                            id="hsqQuestion6_no"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion6"
                                            checked={this.state.form.hsqQuestion6 === "no"}
                                        />
                                        <label htmlFor="hsqQuestion6_no">
                                            <span className="aplcn-check-label">No</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Question 7 */}
                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    7. Do you have any arthritis, back trouble, hip/knee/joint pain or any other bone or joint condition that could be aggravated or made worse by the WCT? <MandatorySymbol />
                                </p>
                                <ul className="aplcn-checklist inline-radios">
                                    <li>
                                        <input
                                            value="yes"
                                            type="radio"
                                            id="hsqQuestion7_yes"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion7"
                                            checked={this.state.form.hsqQuestion7 === "yes"}
                                            required
                                        />
                                        <label htmlFor="hsqQuestion7_yes">
                                            <span className="aplcn-check-label">Yes</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="no"
                                            type="radio"
                                            id="hsqQuestion7_no"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion7"
                                            checked={this.state.form.hsqQuestion7 === "no"}
                                        />
                                        <label htmlFor="hsqQuestion7_no">
                                            <span className="aplcn-check-label">No</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Question 8 */}
                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    8. Do you have personal experience or doctor's advice of any other medical or physical reason that would prohibit you from taking the WCT? <MandatorySymbol />
                                </p>
                                <ul className="aplcn-checklist inline-radios">
                                    <li>
                                        <input
                                            value="yes"
                                            type="radio"
                                            id="hsqQuestion8_yes"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion8"
                                            checked={this.state.form.hsqQuestion8 === "yes"}
                                            required
                                        />
                                        <label htmlFor="hsqQuestion8_yes">
                                            <span className="aplcn-check-label">Yes</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="no"
                                            type="radio"
                                            id="hsqQuestion8_no"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion8"
                                            checked={this.state.form.hsqQuestion8 === "no"}
                                        />
                                        <label htmlFor="hsqQuestion8_no">
                                            <span className="aplcn-check-label">No</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Question 9 */}
                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    9. Has your personal physician recommended against taking the WCT because of asthma, diabetes, epilepsy, elevated cholesterol or a hernia? <MandatorySymbol />
                                </p>
                                <ul className="aplcn-checklist inline-radios">
                                    <li>
                                        <input
                                            value="yes"
                                            type="radio"
                                            id="hsqQuestion9_yes"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion9"
                                            checked={this.state.form.hsqQuestion9 === "yes"}
                                            required
                                        />
                                        <label htmlFor="hsqQuestion9_yes">
                                            <span className="aplcn-check-label">Yes</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="no"
                                            type="radio"
                                            id="hsqQuestion9_no"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion9"
                                            checked={this.state.form.hsqQuestion9 === "no"}
                                        />
                                        <label htmlFor="hsqQuestion9_no">
                                            <span className="aplcn-check-label">No</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Question 10 */}
                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    10. Have you been discharged for any branch of the Armed Forces for issues related to heart problems? <MandatorySymbol />
                                </p>
                                <ul className="aplcn-checklist inline-radios">
                                    <li>
                                        <input
                                            value="yes"
                                            type="radio"
                                            id="hsqQuestion10_yes"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion10"
                                            checked={this.state.form.hsqQuestion10 === "yes"}
                                            required
                                        />
                                        <label htmlFor="hsqQuestion10_yes">
                                            <span className="aplcn-check-label">Yes</span>
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            value="no"
                                            type="radio"
                                            id="hsqQuestion10_no"
                                            onChange={this.setValue.bind(this)}
                                            name="form.hsqQuestion10"
                                            checked={this.state.form.hsqQuestion10 === "no"}
                                        />
                                        <label htmlFor="hsqQuestion10_no">
                                            <span className="aplcn-check-label">No</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="aplcn-form-row-main aplcn-has-inputs">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <p className="aplcn-desc">
                                    Regardless whether you are taking the Work Capacity Test (WCT) at the <u>Arduous</u>, Moderate or Light duty level, a “Yes”
                                    answer requires a determination from your personal physician stating that you are able to participate in the WCT.
                                </p>
                                <p className="aplcn-desc">
                                    I understand that if I need to be evaluated by a physician, it will be bassed on the fitness requirements of the position(s)
                                    for which I am qualified.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Applicant Signature Section */}
                    <div className="aplcn-form-row-main aplcn-has-inputs">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <label className="control-label clearfix">
                                    APPLICANT SIGNATURE:{" "}<MandatorySymbol />
                                </label>
                            </div>
                        </div>
                        <div className="row aplcn-row" style={{ display: 'flex' }}>
                            <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                                <CustomSignaturePad
                                    onSave={(signature) => this.handleSignatureChange("applicantSignature", signature)}
                                    disabled={!this.state.canApply}
                                    error={!!this.state.errors.applicantSignature}
                                    value={this.state.form.applicantSignature}
                                />
                            </div>
                            <div className="col-sm-12 col-md-6 aplcn-inp-wrap" style={{ paddingLeft: '15px' }}>
                                <label className="control-label clearfix">Date <MandatorySymbol /></label>
                                <input
                                    type="text"
                                    name="form.applicantDate"
                                    value={util.formatedDate(this.state.form.applicantDate, "MM/DD/yyyy")}
                                    readOnly
                                    disabled
                                    required
                                    className="hsq-date-disabled"
                                />
                            </div>
                        </div>
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap aplcn-inp-wrap--mb-2">
                                <label className="control-label clearfix">
                                    NAME:{" "}<MandatorySymbol />
                                </label>
                                <input
                                    type="text"
                                    placeholder="Printed Name"
                                    onChange={this.setValue.bind(this)}
                                    onBlur={this.blur.bind(this)}
                                    value={this.state.form.applicantPrintedName}
                                    name="form.applicantPrintedName"
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    {/* Page 2: Work Capacity Test: Informed Consent */}
                    <table border="1">
                        <thead>
                            <th colSpan={2}>
                                <h2 className="text-center h4"><strong>Work Capacity Test: Informed Consent</strong>
                                </h2>
                            </th>
                        </thead>

                        <tbody>
                            <tr valign="top">
                                <td width="50%">
                                    <ul>
                                        <li>
                                            <p>
                                                <strong>Pack Test-Arduous:</strong> The 3-mile walk with a 45-pound pack or vest completed within 45 minutes is strenuous, but no more so that the duties of wildland firefighting.
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                <strong>Field Test -Moderate:</strong> The 2-mile walk with a 25-pound pack or vest completed within 30 minutes is fairly strenuous, but no more so that the field duties.
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                <strong>Walk Test-Light:</strong> The 1-mile walk completed within 16 minutes is moderately strenuous, but no more so that the duties assigned.
                                            </p>
                                        </li>
                                    </ul>
                                </td>
                                <td width="50%">
                                    <p>
                                        <strong>Risks:</strong> There is a slight risk of injury (blisters, sore legs, sprained ankles), especially for those not practiced. You should train for several weeks before taking the test. Warm-up and cool-down are recommended. The risk of more serious consequences (respiratory or heart problems) is diminished by completing the HSQ.
                                    </p>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <div className="aplcn-checklist mb-8">
                                    <input
                                        value="yes"
                                        type="checkbox"
                                        id="consentReadBrochure"
                                        checked={this.state.form.consentReadBrochure === "yes"}
                                        onChange={(e) => {
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    consentReadBrochure: e.target.checked ? "yes" : ""
                                                },
                                                errors: {
                                                    ...this.state.errors,
                                                    consentReadBrochure: ""
                                                }
                                            });
                                        }}
                                        name="form.consentReadBrochure"
                                        title="Form Agreement"
                                        className="aplcn-visible-check"
                                    />

                                    <label htmlFor="consentReadBrochure">
                                        <span className="aplcn-check-label">
                                            I have read the information on this form, the "Work Capacity Test" brochure and understand the purpose, instructions and risks of the job related to work capacity test. <MandatorySymbol />
                                        </span>
                                    </label>
                                </div>
                                {this.state.errors.consentReadBrochure && (
                                    <div className="aplcn-error-message" style={{ color: 'red', marginTop: '5px' }}>
                                        {this.state.errors.consentReadBrochure}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="aplcn-form-row-main">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <div className="aplcn-checklist">
                                    <input
                                        value="yes"
                                        type="checkbox"
                                        id="consentReadHSQ"
                                        checked={this.state.form.consentReadHSQ === "yes"}
                                        onChange={(e) => {
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    consentReadHSQ: e.target.checked ? "yes" : ""
                                                },
                                                errors: {
                                                    ...this.state.errors,
                                                    consentReadHSQ: ""
                                                }
                                            });
                                        }}
                                        name="form.consentReadHSQ"
                                        title="Form Agreement"
                                        className="aplcn-visible-check"
                                    />
                                    <label htmlFor="consentReadHSQ">
                                        <span className="aplcn-check-label">
                                            I have read the information, understood, and truthfully answered the HSQ. <MandatorySymbol />
                                        </span>
                                    </label>
                                </div>
                                {this.state.errors.consentReadHSQ && (
                                    <div className="aplcn-error-message" style={{ color: 'red', marginTop: '5px' }}>
                                        {this.state.errors.consentReadHSQ}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="aplcn-form-section-head">
                        <h5>Test to be taken (check one): <MandatorySymbol /></h5>
                    </div>
                    <div className="aplcn-form-row-main">
                        <ul className="aplcn-checklist test-to-be-taken-checklist">
                            <li>
                                <input
                                    type="checkbox"
                                    id="testToBeTaken_arduous"
                                    name="testToBeTaken"
                                    title="Test to be taken"
                                    disabled
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    testToBeTaken: "arduous_pack_test"
                                                },
                                                errors: {
                                                    ...this.state.errors,
                                                    testToBeTaken: ""
                                                }
                                            });
                                        } else {
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    testToBeTaken: ""
                                                }
                                            });
                                        }
                                    }}
                                    checked={this.state.form.testToBeTaken === "arduous_pack_test"}
                                />
                                <label htmlFor="testToBeTaken_arduous">
                                    <span className="aplcn-check-label">Arduous, Pack Test</span>
                                </label>
                            </li>
                            <li>
                                <input
                                    type="checkbox"
                                    id="testToBeTaken_moderate"
                                    name="testToBeTaken"
                                    title="Test to be taken"
                                    disabled
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            // Uncheck other options
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    testToBeTaken: "moderate_field_test"
                                                },
                                                errors: {
                                                    ...this.state.errors,
                                                    testToBeTaken: ""
                                                }
                                            });
                                        } else {
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    testToBeTaken: ""
                                                }
                                            });
                                        }
                                    }}
                                    checked={this.state.form.testToBeTaken === "moderate_field_test"}
                                />
                                <label htmlFor="testToBeTaken_moderate">
                                    <span className="aplcn-check-label">Moderate, Field Test</span>
                                </label>
                            </li>
                            <li>
                                <input
                                    type="checkbox"
                                    id="testToBeTaken_light"
                                    name="testToBeTaken"
                                    title="Test to be taken"
                                    disabled
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            // Uncheck other options
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    testToBeTaken: "light_walk_test"
                                                },
                                                errors: {
                                                    ...this.state.errors,
                                                    testToBeTaken: ""
                                                }
                                            });
                                        } else {
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    testToBeTaken: ""
                                                }
                                            });
                                        }
                                    }}
                                    checked={this.state.form.testToBeTaken === "light_walk_test"}
                                />
                                <label htmlFor="testToBeTaken_light">
                                    <span className="aplcn-check-label">Light, Walk Test</span>
                                </label>
                            </li>
                        </ul>
                        {this.state.errors.testToBeTaken && (
                            <div className="aplcn-error-message" style={{ color: 'red', marginTop: '5px' }}>
                                {this.state.errors.testToBeTaken}
                            </div>
                        )}
                    </div>

                    {/* Consent Signature Section */}
                    <div className="aplcn-form-section-head">
                    </div>
                    <div className="aplcn-form-row-main aplcn-has-inputs">
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <label className="control-label clearfix">
                                    SIGNATURE:{" "}<MandatorySymbol />
                                </label>
                            </div>
                        </div>
                        <div className="row aplcn-row" style={{ display: 'flex' }}>
                            <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                                <CustomSignaturePad
                                    onSave={(signature) => this.handleSignatureChange("consentSignature", signature)}
                                    disabled={!this.state.canApply}
                                    error={!!this.state.errors.consentSignature}
                                    value={this.state.form.consentSignature}
                                />
                            </div>
                            <div className="col-sm-12 col-md-6 aplcn-inp-wrap" style={{ paddingLeft: '15px' }}>
                                <label className="control-label clearfix">Date <MandatorySymbol /></label>
                                <input
                                    type="text"
                                    name="form.consentDate"
                                    value={util.formatedDate(this.state.form.consentDate, "MM/DD/yyyy")}
                                    readOnly
                                    disabled
                                    required
                                    className="hsq-date-disabled"
                                />
                            </div>
                        </div>
                        <div className="row aplcn-row">
                            <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                                <label className="control-label clearfix">
                                    NAME:{" "}<MandatorySymbol />
                                </label>
                                <input
                                    type="text"
                                    placeholder="Printed Name"
                                    onChange={this.setValue.bind(this)}
                                    onBlur={this.blur.bind(this)}
                                    value={this.state.form.consentPrintedName}
                                    name="form.consentPrintedName"
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 aplcn-form-main-actionbar">
                            <div className="aplcn-form-actionbar">
                                <button
                                    onClick={this.back.bind(this)}
                                    type="button"
                                    disabled=""
                                    className="aplcn-prev-button"
                                >
                                    Previous
                                </button>
                                <button type="submit" className="aplcn-next-btn">
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    back(event) {
        event.preventDefault();
        this.props.back(step);
    }
}
function mapStateToProps(state) {
    return state;
}
const connectedApp = connect(mapStateToProps)(HsqDocument);
export { connectedApp as HsqDocument };
